import { render, staticRenderFns } from "./ExamBox.vue?vue&type=template&id=0220c15f&scoped=true"
import script from "./ExamBox.vue?vue&type=script&lang=js"
export * from "./ExamBox.vue?vue&type=script&lang=js"
import style0 from "./ExamBox.vue?vue&type=style&index=0&id=0220c15f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0220c15f",
  null
  
)

export default component.exports